import { useTranslation } from 'react-i18next';
import useAppContext from '/business/shared/hooks/useAppContext';
import { apiEndpoint } from '/shared/util/Statics';

export const useGetBusinessDocuments = () => {
  const { documents = {} } = useAppContext();
  const { i18n } = useTranslation();
  const lang = documents[i18n.languages[0]] ? i18n.languages[0] : 'en';
  // const { methodologyStatement } = documents[lang];
  // const { termsAndConditions } = documents[lang];

  const methodologyStatement = `${apiEndpoint}/api/b2b/get_static_file?type=methodology`;
  const termsAndConditions = `${apiEndpoint}/api/b2b/get_static_file?type=termsconditions`;
  const checklist = `${apiEndpoint}/api/b2b/get_static_file?type=checklist`;

  return { methodologyStatement, termsAndConditions, checklist };
};
